// extracted by mini-css-extract-plugin
export default {"intro":"About_intro__OLChp","name":"About_name__cYoQT","hire":"About_hire__+9i6c","icons":"About_icons__AQbjE","right":"About_right__JzWV-","my_img":"About_my_img__cRT+r"};